import { RootState } from "../../../store";
import { WidgetSetupType } from "../../utils/types/types";

export const widgetSetupSelector = (
  state: RootState,
): WidgetSetupType | null => {
  return state.dashboards?.setup;
};
